import { render, staticRenderFns } from "./batch-form-dz.vue?vue&type=template&id=3996f9f5&"
import script from "./batch-form-dz.vue?vue&type=script&lang=js&"
export * from "./batch-form-dz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "batch-form-dz.vue"
export default component.exports